import React from 'react'

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: Array<{ value: string, label: string }>
}
const PlainSelect: React.FC<Props> = ({ options, name, value, onChange }) => {
  return (
    <select onChange={onChange} name={name} value={value} className='border-0 outline-0 bg-transparent'>
      {options.map((option) => (
        <option key={option.value} value={option.value}>{option.label}</option>
      ))}
    </select>
  )
}

export default PlainSelect
